<template>
  <div>
    test2
  </div>
</template>

<script>

import announcementSocket from '@/libs/sockets/announcements'

export default {
  name: 'Public.NotifySchedules',
  data () {
    return {
      servers: {
        announcements: {
          domain: typeof this.$route.query.domain !== 'undefined' ? this.$route.query.domain : '',
          port: typeof this.$route.query.port !== 'undefined' ? this.$route.query.port : '',
          pivot: {
            namespace: typeof this.$route.query.namespace !== 'undefined' ? this.$route.query.namespace : ''
          }
        }
      }
    }
  },
  mounted () {
    announcementSocket.setNode(this.servers)
    announcementSocket.getSocket().emit('new_announcement_added')
  }
}

</script>

<style lang="scss">
</style>